export var PERSONAL_EMAIL_DOMAINS = new Set([
    "gmail.com",
    "calendar.google.com",
    "yahoo.com",
    "hotmail.com",
    "outlook.com",
    "aol.com",
    "zoho.com",
    "mail.com",
    "protonmail.com",
    "gmx.com",
    "yandex.com",
    "hushmail.com",
    "inbox.com",
    "fastmail.com",
    "lycos.com",
    "icloud.com",
    "shortmail.com",
    "tutanota.com",
    "runbox.com",
    "vfemail.net",
    "mailbox.org",
    "mailfence.com",
    "posteo.de",
    "startmail.com",
    "trashmail.com",
    "cock.li",
    "countermail.com",
    "kolabnow.com",
    "thexyz.com",
    "securenym.net",
    "mailpile.is",
    "mailoo.org",
    "bitmessage.ch",
    "ghostmail.com",
    "inbox.lv",
    "mail.ee",
    "mail.bg",
    "mail.ru",
    "yandex.ru",
    "list.ru",
    "bk.ru",
    "inbox.ru",
    "internet.ru",
    "fromru.com",
    "rambler.ru",
    "hotmail.ru",
    "yahoo.ru",
    "aol.ru",
    "pochta.ru",
    "yandex.ua",
    "mail.ua",
    "i.ua",
    "meta.ua",
    "bigmir.net",
    "ukr.net",
    "hotmail.co.uk",
    "yahoo.co.uk",
    "aol.co.uk",
    "mail.co.uk",
    "gmx.co.uk",
    "yandex.by",
    "mail.by",
    "tut.by",
    "hotmail.fr",
    "yahoo.fr",
    "aol.fr",
    "gmx.fr",
    "mail.fr",
    "laposte.net",
    "free.fr",
    "sfr.fr",
    "orange.fr",
    "bouygtel.fr",
    "hotmail.de",
    "yahoo.de",
    "aol.de",
    "gmx.de",
    "mail.de",
    "web.de",
    "t-online.de",
    "hotmail.it",
    "yahoo.it",
    "aol.it",
    "gmx.it",
    "mail.it",
    "libero.it",
    "virgilio.it",
    "hotmail.es",
    "yahoo.es",
    "aol.es",
    "gmx.es",
    "mail.es",
    "hotmail.ca",
    "yahoo.ca",
    "aol.ca",
    "gmx.ca",
    "mail.ca",
    "hotmail.au",
    "yahoo.au",
    "aol.au",
    "gmx.au",
    "mail.au",
    "msn.com",
    "live.com"
]);
